"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    map: {
        path: "/map",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFwcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvbWFwcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtQ0FBc0M7QUFFekIsUUFBQSxNQUFNLEdBQUcsSUFBQSxtQkFBVyxFQUFDO0lBQ2hDLEdBQUcsRUFBRTtRQUNILElBQUksRUFBRSxNQUFNO0tBQ2I7Q0FDRixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIG1hcDoge1xuICAgIHBhdGg6IFwiL21hcFwiLFxuICB9LFxufSk7XG4iXX0=